<script setup>
import { computed } from 'vue';
import BaseBubble from 'next/message/bubbles/Base.vue';
import { useMessageContext } from '../provider.js';

const { content, contentAttributes } = useMessageContext();

const cards = computed(() => {
  return contentAttributes.value?.items || [];
});
</script>

<template>
  <BaseBubble class="p-0 overflow-hidden" data-bubble-name="cards">
    <div class="flex flex-col gap-2">
      <div
        v-for="(card, index) in cards"
        :key="index"
        class="bg-n-alpha-2 rounded-xl overflow-hidden max-w-80"
      >
        <img
          v-if="card.media_url"
          :src="card.media_url"
          :alt="card.title"
          class="w-full h-40 object-cover"
        />
        <div class="p-3 flex flex-col gap-2">
          <h6 v-if="card.title" class="font-semibold text-n-slate-12">
            {{ card.title }}
          </h6>
          <p v-if="card.description" class="text-sm text-n-slate-11">
            {{ card.description }}
          </p>
          <div v-if="card.actions?.length" class="flex flex-col gap-1 mt-1">
            <a
              v-for="(action, actionIndex) in card.actions"
              :key="actionIndex"
              :href="action.uri"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center justify-center px-3 py-1.5 text-sm font-medium text-woot-500 bg-woot-50 dark:bg-woot-800/20 rounded-lg hover:bg-woot-100 dark:hover:bg-woot-800/30 transition-colors"
            >
              {{ action.text }}
              <svg
                class="w-4 h-4 ml-1"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <!-- Fallback if no cards but has content -->
      <div v-if="!cards.length && content" class="px-4 py-3 text-n-slate-12">
        {{ content }}
      </div>
    </div>
  </BaseBubble>
</template>

